export const MESSAGE_MOVE_CHANNEL_COUNT_MAX: number = 100;

export const MESSAGE_MOVE_TYPE_FIELD_NAME = "messageMoveType";

export const MESSAGE_MOVE_NOTIFICATION = {
  COPY: "Message copied",
  MOVE: "Message moved",
};
